import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
} from "@mui/joy";
import NewsImage from "./NewsImage";
import NewsHeader from "./NewsHeader";
import NewsTitle from "./NewsTitle";
import NewsTags from "./NewsTags";
import NewsFooter from "./NewsFooter";

function NewsCard({ article }) {
  return (
    <Grid xs={12}>
      <Card
        variant="outlined"
        sx={{
          mb: 3,
          overflow: 'hidden',
          borderRadius: "12px",
          minHeight: "140px",
        }}
      >
        <Grid container>
          <NewsImage imageUrl={article.imageUrl} title={article.title} />
          <Grid xs={12} md={9}>
            <CardContent sx={{
              px: 2,
              py: 1.5,
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}>
              <Box>
                <NewsHeader website={article.website} category={article.category} />
                <NewsTitle title={article.title} secondaryTitle={article.secondaryTitle} />
                <NewsTags tags={article.tags} />
              </Box>
              <Divider sx={{ my: 0.5 }} />
              <NewsFooter author={article.author} publishedAt={article.publishedAt} />
            </CardContent>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
}

export default NewsCard;